import { Typography, makeStyles } from '@material-ui/core';
import { PatientCounter } from '../../ControlPanel/components';

const useStyles = makeStyles((theme) => ({
  chartHeader: {
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #F0F1F4',
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  chartTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  chartTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#1F2937',
    margin: 0,
  },
  chartSubtitle: {
    fontSize: 13,
    color: '#6B7280',
    marginTop: 4,
  },
}));

const ChartHeader = ({ title, subtitle }) => {
  const classes = useStyles();

  return (
    <div className={classes.chartHeader}>
      <div className={classes.chartTitleContainer}>
        <Typography className={classes.chartTitle}>
          {title}
        </Typography>
        <Typography className={classes.chartSubtitle}>
          {subtitle}
        </Typography>
      </div>
      <PatientCounter />
    </div>
  );
};

export default ChartHeader;
